import { colors } from '../colors.js';

var textInput = {
    base: {
        display: "flex",
        alignItems: "stretch",
        boxSizing: "border-box",
        font: "inherit",
        margin: 0,
        overflow: "visible",
        fontFamily: "body",
        color: "text",
        backgroundColor: "white",
        borderColor: "black.20",
        borderStyle: "solid",
        borderWidth: 1,
        borderRadius: 3,
        fontSize: 3,
        height: "var(--text-input-height)",
        lineHeight: 4,
        width: "100%",
        // https://caniuse.com/?search=focus-within
        // :focus-within is available with most 2017+ browsers so i think it's reasonable to use
        "&[data-focus], :focus-within": {
            boxShadow: "0 0 0 4px ".concat(colors.primary["20"]),
            borderColor: "primary.100",
        },
        "&[data-disabled]": {
            backgroundColor: "black.5",
        },
    },
    variants: {
        invalid: {
            true: {
                borderColor: "critical.60",
            },
        },
        disabled: {
            true: {
                backgroundColor: "black.5",
            },
        },
        size: {
            sm: {
                fontSize: 2,
                "--text-input-height": "33px",
                padding: "6px 8px",
            },
            md: {
                "--text-input-height": "44px",
                padding: "0 16px",
            },
            lg: {
                "--text-input-height": "56px",
                padding: "16px",
            },
        },
    },
    defaultProps: {
        size: "md",
    },
};
var textInputEnds = {
    base: {
        boxSizing: "border-box",
        backgroundColor: "black.5",
        display: "flex",
        alignItems: "center",
        borderColor: "black.20",
        borderStyle: "solid",
        borderWidth: 0,
        fontSize: 3,
    },
    variants: {
        size: {
            sm: {
                fontSize: 2,
                paddingX: "12px",
            },
            md: {
                paddingX: "16px",
            },
            lg: {
                paddingX: "16px",
            },
        },
        end: {
            prefix: {
                borderTopLeftRadius: 3,
                borderBottomLeftRadius: 3,
                borderRightWidth: 1,
            },
            suffix: {
                borderTopRightRadius: 3,
                borderBottomRightRadius: 3,
                borderLeftWidth: 1,
            },
        },
    },
    defaultProps: {
        size: "md",
        end: "prefix",
    },
};

export { textInput, textInputEnds };
//# sourceMappingURL=text-input.js.map
